/* eslint-disable react/no-unknown-property */
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import { ROUTE_TYPE } from '../../Configuration'
import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import { PreviousPageContext } from '../../store/previous-page-provider'
import './dashboard-kpis.css'

interface DashboardKPIsProps {
  dashboardKPIs: any
  inquiryFilterProps?: any
  switchMode: string
  tab: number
}
const DashboardKPIs = ({ dashboardKPIs, switchMode, tab }: DashboardKPIsProps) => {
  const { setKPIClicked } = useContext(PreviousPageContext)

  const routeKPIs = (title) => {
    const filters = {
      ACTIVE: {
        AssignedComponentCode: tab,
        activeFilter: true,
        assignedComponentCodeFilter: tab,
        tabTable:'ACTIVE',
        unassignedFilter: undefined,
      },
      'DUE OUTS': {
        assignedComponentCodeFilter: tab,
      },
      'TOTAL INQUIRIES': {
        AssignedComponentCode: tab,
        activeFilter: undefined,
        assignedComponentCodeFilter: tab,
        tabTable:'ALL INQUIRIES',
        unassignedFilter: undefined,

      },
      UNASSIGNED: {
        AssignedComponentCode: tab,
        activeFilter: undefined,
        assignedComponentCodeFilter: tab,
        tabTable:'UNASSIGNED',
        unassignedFilter: true
      },
    }
    return filters[title]
  }

  return (
    <div className='row my-2 dashboardkpis gap-2'>
      {dashboardKPIs.map((KPI) => (
        <div className='col m-0' key={KPI.title}>
          <a
            className={
              switchMode === KPI?.name
                ? 'card shadow p-0 w-100 d-flex kpiborder justify-content-between card-body h-100 active'
                : 'card shadow p-0 w-100 d-flex kpiborder justify-content-between card-body h-100'
            }
            status-kpis={KPI.kpicode}
            tabIndex={0}
            title={`${KPI.title}`}
          >
            {KPI.title !== 'DUE OUTS' ? (
              <Link
                className='link-container'
                state={{ inqFilter: routeKPIs(KPI.title) }}
                title={`${KPI.title}`}
                to={`${ROUTE_TYPE}inquiries`}
              >
                <h2 className='dashboard-kpi-title p-2 ps-3 darktext d-flex align-items-center poppins-bold font-14'>
                  {defaultToEmptyString(KPI.title)}
                </h2>
                <h2 className='border-left3  p-2 px-3 color-primary d-flex align-items-center poppins-bold font-22'>
                  {defaultToEmptyString(KPI.count)}
                </h2>
              </Link>
            ) : (
              <Link
                className='link-container'
                onClick={() => setKPIClicked(true)}
                state={{ dueFilter: routeKPIs(KPI.title) }}
                title='DUE OUTS'
                to={`${ROUTE_TYPE}dueouts`}
              >
                <h2 className='dashboard-kpi-title p-2 ps-3 darktext d-flex align-items-center poppins-bold font-14'>
                  {defaultToEmptyString(KPI.title)}
                </h2>
                <h2 className='border-left3  p-2 px-3 color-primary d-flex align-items-center poppins-bold font-22'>
                  {defaultToEmptyString(KPI.count)}
                </h2>
              </Link>
            )}
          </a>
        </div>
      ))}
    </div>
  )
}
export default DashboardKPIs
